import styled from 'styled-components';

/**
 * A wrapper for `Dialog` content.
 *
 * @related [`Dialog`]
 * @since 8.60.0
 */
var DialogLayout = /*#__PURE__*/styled.div.withConfig({
  displayName: "DialogLayout",
  componentId: "c11n-8-111-1__sc-12q10c7-0"
})([""]);
DialogLayout.displayName = 'DialogLayout';

/** @component */
export { DialogLayout };